import { h, Host } from "@stencil/core";
import { ReportItem } from "./report-row";
export class PaginatedReportItems {
    constructor() {
        /** The list of service documents to display */
        this.items = [];
        /** Whether the component is used on a machine page */
        this.isOnMachinePage = false;
        this.visibleAmount = PaginatedReportItems.pageSize;
    }
    /**
     * Load more items when the button is clicked
     */
    loadMore() {
        this.visibleAmount += PaginatedReportItems.pageSize;
    }
    render() {
        return (h(Host, { key: '250a8d0ae074c815187b8c7d948f7cb32f373ab0' }, this.items.slice(0, this.visibleAmount).map((doc) => (h("div", { class: "ux-info-box" }, h(ReportItem, { t: this.t, document: doc, title: this.t(`mf-service-calls:serviceReports.reportTypes.${doc.mission.assignmentType}`), isOnMachinePage: this.isOnMachinePage })))), this.visibleAmount < this.items.length && (h("ux-button", { key: '487b657c5643df3b1982f7653c87a43d77964d2e', class: "mf-service-reports__load-more", onClick: () => this.loadMore() }, this.t("mf-service-calls:serviceReports.loadMore")))));
    }
    static get is() { return "mf-service-reports-paginated-items"; }
    static get properties() {
        return {
            "items": {
                "type": "unknown",
                "attribute": "items",
                "mutable": false,
                "complexType": {
                    "original": "ServiceDocument[]",
                    "resolved": "ServiceDocument[]",
                    "references": {
                        "ServiceDocument": {
                            "location": "import",
                            "path": "../../api/publicApi/serviceReports/document",
                            "id": "src/api/publicApi/serviceReports/document.ts::ServiceDocument"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The list of service documents to display"
                },
                "getter": false,
                "setter": false,
                "defaultValue": "[]"
            },
            "t": {
                "type": "unknown",
                "attribute": "t",
                "mutable": false,
                "complexType": {
                    "original": "(key: string, options?: Record<string, unknown>) => string",
                    "resolved": "(key: string, options?: Record<string, unknown> | undefined) => string",
                    "references": {
                        "Record": {
                            "location": "global",
                            "id": "global::Record"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The function to translate keys"
                },
                "getter": false,
                "setter": false
            },
            "isOnMachinePage": {
                "type": "boolean",
                "attribute": "is-on-machine-page",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether the component is used on a machine page"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "visibleAmount": {}
        };
    }
}
PaginatedReportItems.pageSize = 5;
//# sourceMappingURL=paginated-report-items.js.map
